import * as React from "react";
import { observer } from "mobx-react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";
import { Pager } from "../utils/Pager";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, H5, InputGroup, Intent, Popover, Position, Tab, Tabs, TextArea, Tooltip } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { toast } from "react-toastify";
import { ProdutoGenericoSelect, filterProduto, renderProduto } from "../utils/ProdutoGenericoSelect";
import { IProdutoGenerico, newIProdutoGenerico } from "../../model";
import LoadingModal from "../loading/LoadingModal";

const InputMask = require("react-input-mask");

var debounce = require('lodash.debounce');

@observer
export default class ProdutosSped extends React.Component<{}, {}> {

    obs = observable({
        open_adiciona_cfop_produto: false as boolean,
        open_create_produto_generico: false as boolean,
        cfop_estadual_entrada: "" as string,
        cfop_interestadual_entrada: "" as string,
        cfop_estadual_saida: "" as string,
        cfop_interestadual_saida: "" as string,
        produto_generico_cest: "" as string,
        produto_generico_ncm: "" as string,
        produto_generico_descricao: "" as string,
        produto_generico_gtin: "" as string,
        produto_generico_unidade: "" as string,
        selectedGenericProduto: newIProdutoGenerico() as IProdutoGenerico,
        open_edit_produto: false as boolean,
        produto_cest: "" as string,
        produto_ncm: "" as string,
        produto_descricao: "" as string,
        produto_gtin: "" as string,
        produto_id: "" as string,
        select_tab_generic: "create_generic" as string,
        generic_id: "" as string,
        produto_unidade: "" as string,
        produto_cnpj: "" as string,
        open_adiciona_cfops_estadual_entrada: false as boolean,
        open_adiciona_cfops_estadual_saida: false as boolean,
        open_adiciona_cfops_interestadual_entrada: false as boolean,
        open_adiciona_cfops_interestadual_saida: false as boolean,
        fetchOptions: {} as any
    })


    constructor(props: any) {
        super(props);

      this.obs.fetchOptions = debounce(this.handleBuscaProdutos.bind(this), 800);

    }

    async handleBuscaCFOPEntrada(e) {
        SpedEfdStore.obs.input_cfop_entrada_especifico = e
        let data = e?.replace(/\_/g, "").replace(/\-/g, "")

        if (data.length == 4) {
            await SpedEfdStore.handleBuscaCfopEntrada(e)
        }
    }

    async handleBuscaCFOPSaida(e) {
        SpedEfdStore.obs.input_cfop_saida_especifico = e
        let data = e?.replace(/\_/g, "").replace(/\-/g, "")

        if (data.length == 4) {
            await SpedEfdStore.handleBuscaCfopSaida(e)
        }
    }

    handleChangePage(e: any) {
        SpedEfdStore.handleBuscaProdutos(SpedEfdStore.obs.selectedEmpresa.cnpj, SpedEfdStore.obs.produtos_current, SpedEfdStore.obs.filter_produtos_sped)
    }

    onSelectAll = (isSelect, rows) => {
        if (isSelect) {

            SpedEfdStore.setDeletarItemsList(rows);
        } else {
            SpedEfdStore.resetDeletarItems();
        }
    };

    onSelect = (row, checked) => {

        if (checked) {
            SpedEfdStore.setDeletearItems(row);
        } else {
            SpedEfdStore.deleteByIdProdutosItems(row.id);
        }
    };

    async handleDeletar() {
        await SpedEfdStore.handleDeleteProdutos()
    }

    async handleDeletarTodos() {
        SpedEfdStore.selectAllContestarLote();
        await SpedEfdStore.handleBuscaProdutosAll(SpedEfdStore.obs.selectedEmpresa.cnpj, SpedEfdStore.obs.filter_produtos_sped)
    }

    handleBuscaPaged(filtro: string) {
        SpedEfdStore.obs.filter_produtos_sped = filtro
        SpedEfdStore.obs.produtos_current = 1

        this.obs.fetchOptions()

    }

    async handleBuscaProdutos() {

      await SpedEfdStore.handleBuscaProdutos(SpedEfdStore.obs.selectedEmpresa.cnpj, SpedEfdStore.obs.produtos_current, SpedEfdStore.obs.filter_produtos_sped)

    }

    handleIncluirCfopProduto() {
        this.obs.open_adiciona_cfop_produto = true
    }

    handleProdutoGenerico() {
        SpedEfdStore.handleBuscaProdutosGenericosAll(SpedEfdStore.obs.selectedEmpresa.cnpj)

        this.obs.open_create_produto_generico = true
    }

    hanldeChangeTabGeneric(tab: string) {
        this.obs.select_tab_generic = tab;
        this.obs.selectedGenericProduto = newIProdutoGenerico()
    }

    async handleSaveCfopProduto() {
        if (this.obs.cfop_estadual_entrada == "" && this.obs.cfop_interestadual_entrada == "" && this.obs.cfop_estadual_saida == "" && this.obs.cfop_interestadual_saida == "") {
            toast.warning('Insira um CFOP!', {});
            return;
        }

        if (this.obs.cfop_estadual_entrada != "" && SpedEfdStore.obs.cfop_entrada_estadual_especifico == "") {
            toast.warning('É necessário cadastrar o(s) CFOP(s) de saída para o CFOP de Entrada Estadual!', {});
            return;
        }

        if (this.obs.cfop_interestadual_entrada != "" && SpedEfdStore.obs.cfop_entrada_interestadual_especifico == "") {
            toast.warning('É necessário cadastrar o(s) CFOP(s) de saída para o CFOP de Entrada Interestadual!', {});
            return;
        }

        if (this.obs.cfop_estadual_saida != "" && SpedEfdStore.obs.cfop_saida_estadual_especifico == "") {
            toast.warning('É necessário cadastrar o(s) CFOP(s) de entrada para o CFOP de Saída Estadual!', {});
            return;
        }

        if (this.obs.cfop_interestadual_saida != "" && SpedEfdStore.obs.cfop_saida_interestadual_especifico == "") {
            toast.warning('É necessário cadastrar o(s) CFOP(s) de entrada para o CFOP de Saída Interestadual!', {});
            return;
        }

        let params = {
            produtos: SpedEfdStore.obs.deletarProdutos,
            cfop_estadual_entrada: this.obs.cfop_estadual_entrada,
            cfop_estadual_saida: this.obs.cfop_estadual_saida,
            cfop_interestadual_entrada: this.obs.cfop_interestadual_entrada,
            cfop_interestadual_saida: this.obs.cfop_interestadual_saida,
            cfop_entrada_estadual_especifico: SpedEfdStore.obs.cfop_entrada_estadual_especifico,
            cfop_saida_estadual_especifico: SpedEfdStore.obs.cfop_saida_estadual_especifico,
            cfop_entrada_interestadual_especifico: SpedEfdStore.obs.cfop_entrada_interestadual_especifico,
            cfop_saida_interestadual_especifico: SpedEfdStore.obs.cfop_saida_interestadual_especifico,
        }

        await SpedEfdStore.handleSaveCfopProduto(params)
        this.cleanOnClose()
    }

    async handleSaveProdutoGenerico() {

        if (this.obs.selectedGenericProduto.descricao == "") {

            if (this.obs.produto_generico_cest != "" && this.obs.produto_generico_cest.replace(/\_/g, "").length != 9) {
                toast.warning('Insira uma CEST!', {});
                return;
            }

            if (this.obs.produto_generico_ncm == "" || this.obs.produto_generico_ncm.replace(/\_/g, "").length != 10) {
                toast.warning('Insira um NCM!', {});
                return;
            }

            if (this.obs.produto_generico_unidade == "") {
                toast.warning('Insira uma Unidade!', {});
                return;
            }

            if (this.obs.produto_generico_descricao == "") {
                toast.warning('Insira uma Descrição!', {});
                return;
            }

            let params = {
                produtos: SpedEfdStore.obs.deletarProdutos,
                cest: this.obs.produto_generico_cest.replace(/\./g, ""),
                ncm_sh: this.obs.produto_generico_ncm.replace(/\./g, ""),
                descricao: this.obs.produto_generico_descricao,
                gtin: this.obs.produto_generico_gtin,
                unidade: this.obs.produto_generico_unidade,
                cnpj: SpedEfdStore.obs.selectedEmpresa.cnpj
            }

            this.obs.open_create_produto_generico = false
            await SpedEfdStore.handleCreateProdutoGenerico(params)
            this.onCloseGeneric()
        } else {

            let params = {
                id: this.obs.selectedGenericProduto.id,
                produtos: SpedEfdStore.obs.deletarProdutos,
            }

            this.obs.open_create_produto_generico = false
            await SpedEfdStore.handleVincularGenerico(params)
            this.onCloseGeneric()
        }

        this.cleanOnClose()
    }

    handleEditCFOPS(row) {
        this.obs.open_adiciona_cfop_produto = true
        this.obs.cfop_estadual_entrada = row.cfop_estadual_entrada
        this.obs.cfop_estadual_saida = row.cfop_estadual_saida
        this.obs.cfop_interestadual_entrada = row.cfop_interestadual_entrada
        this.obs.cfop_interestadual_saida = row.cfop_interestadual_saida
        SpedEfdStore.obs.cfop_entrada_estadual_especifico = row.cfop_entrada_estadual_especifico
        SpedEfdStore.obs.cfop_saida_estadual_especifico = row.cfop_saida_estadual_especifico
        SpedEfdStore.obs.cfop_entrada_interestadual_especifico = row.cfop_entrada_interestadual_especifico
        SpedEfdStore.obs.cfop_saida_interestadual_especifico = row.cfop_saida_interestadual_especifico

        SpedEfdStore.obs.deletarProdutos.push(row)
    }

    deleteCfopSaidaEstadualEspecifico(codigo: string) {
        SpedEfdStore.obs.cfop_entrada_estadual_especifico = SpedEfdStore.obs.cfop_entrada_estadual_especifico.filter(
            (item: any) => {
                return item.codigo != codigo;
            },
        );
        SpedEfdStore.obs.cfops_selecionados = SpedEfdStore.obs.cfop_entrada_estadual_especifico?.map(value => {
            return value.codigo;
        });
    }

    deleteCfopEntradaEstadualEspecifico(codigo: string) {
        SpedEfdStore.obs.cfop_saida_estadual_especifico = SpedEfdStore.obs.cfop_saida_estadual_especifico.filter(
            (item: any) => {
                return item.codigo != codigo;
            },
        );
        SpedEfdStore.obs.cfops_selecionados = SpedEfdStore.obs.cfop_saida_estadual_especifico?.map(value => {
            return value.codigo;
        });
    }

    deleteCfopSaidaInterEspecifico(codigo: string) {
        SpedEfdStore.obs.cfop_entrada_interestadual_especifico = SpedEfdStore.obs.cfop_entrada_interestadual_especifico.filter(
            (item: any) => {
                return item.codigo != codigo;
            },
        );
        SpedEfdStore.obs.cfops_selecionados = SpedEfdStore.obs.cfop_entrada_interestadual_especifico?.map(value => {
            return value.codigo;
        });
    }

    deleteCfopEntradaInterEspecifico(codigo: string) {
        SpedEfdStore.obs.cfop_saida_interestadual_especifico = SpedEfdStore.obs.cfop_saida_interestadual_especifico.filter(
            (item: any) => {
                return item.codigo != codigo;
            },
        );
        SpedEfdStore.obs.cfops_selecionados = SpedEfdStore.obs.cfop_saida_interestadual_especifico?.map(value => {
            return value.codigo;
        });
    }

    async InserirCFOPSaidaEstadual() {
        let cfop_saida = SpedEfdStore.obs.input_cfop_saida_especifico?.replace(/\-/g, "").replace(/\_/g, "")

        if (SpedEfdStore.obs.cfop_saida_descricao == "") {
            return;
        }

        if (cfop_saida == "") {
            toast.warning('CFOP Inválido', {});
            return;
        }

        let validaCFOP = SpedEfdStore.obs.cfop_entrada_estadual_especifico?.map(value => {
            return value.codigo;
        });

        if (validaCFOP.indexOf(cfop_saida) > -1) {
            toast.warning('CFOP já cadastrado', {});
            return;
        } else {
            SpedEfdStore.obs.cfop_entrada_estadual_especifico = [...SpedEfdStore.obs.cfop_entrada_estadual_especifico, { codigo: cfop_saida, descricao: SpedEfdStore.obs.cfop_saida_descricao }];
            SpedEfdStore.obs.input_cfop_saida_especifico = ""
            SpedEfdStore.obs.cfop_saida_descricao = ""
        }
    }

    async InserirCFOPSaidaInterestadual() {
        let cfop_saida = SpedEfdStore.obs.input_cfop_saida_especifico?.replace(/\-/g, "").replace(/\_/g, "")


        if (SpedEfdStore.obs.cfop_saida_descricao == "") {
            return;
        }


        if (cfop_saida == "") {
            toast.warning('CFOP Inválido', {});
            return;
        }

        let validaCFOP = SpedEfdStore.obs.cfop_entrada_interestadual_especifico?.map(value => {
            return value.codigo;
        });

        if (validaCFOP.indexOf(cfop_saida) > -1) {
            toast.warning('CFOP já cadastrado', {});
            return;
        } else {
            SpedEfdStore.obs.cfop_entrada_interestadual_especifico = [...SpedEfdStore.obs.cfop_entrada_interestadual_especifico, { codigo: cfop_saida, descricao: SpedEfdStore.obs.cfop_saida_descricao }];
            SpedEfdStore.obs.input_cfop_saida_especifico = ""
            SpedEfdStore.obs.cfop_saida_descricao = ""
        }
    }

    async InserirCFOPEntradaEstadual() {
        let cfop_entrada = SpedEfdStore.obs.input_cfop_entrada_especifico?.replace(/\-/g, "").replace(/\_/g, "")

        if (SpedEfdStore.obs.cfop_entrada_descricao == "") {
            return;
        }

        if (cfop_entrada == "") {
            toast.warning('CFOP Inválido', {});
            return;
        }

        let validaCFOP = SpedEfdStore.obs.cfop_saida_estadual_especifico?.map(value => {
            return value.codigo;
        });

        if (validaCFOP.indexOf(cfop_entrada) > -1) {
            toast.warning('CFOP já cadastrado', {});
            return;
        } else {
            SpedEfdStore.obs.cfop_saida_estadual_especifico = [...SpedEfdStore.obs.cfop_saida_estadual_especifico, { codigo: cfop_entrada, descricao: SpedEfdStore.obs.cfop_entrada_descricao }];
            SpedEfdStore.obs.input_cfop_entrada_especifico = ""
            SpedEfdStore.obs.cfop_entrada_descricao = ""
        }
    }

    async InserirCFOPEntradaInterestadual() {
        let cfop_entrada = SpedEfdStore.obs.input_cfop_entrada_especifico?.replace(/\-/g, "").replace(/\_/g, "")

        if (SpedEfdStore.obs.cfop_entrada_descricao == "") {
            return;
        }

        if (cfop_entrada == "") {
            toast.warning('CFOP Inválido', {});
            return;
        }

        let validaCFOP = SpedEfdStore.obs.cfop_saida_interestadual_especifico?.map(value => {
            return value.codigo;
        });

        if (validaCFOP.indexOf(cfop_entrada) > -1) {
            toast.warning('CFOP já cadastrado', {});
            return;
        } else {
            SpedEfdStore.obs.cfop_saida_interestadual_especifico = [...SpedEfdStore.obs.cfop_saida_interestadual_especifico, { codigo: cfop_entrada, descricao: SpedEfdStore.obs.cfop_entrada_descricao }];
            SpedEfdStore.obs.input_cfop_entrada_especifico = ""
            SpedEfdStore.obs.cfop_entrada_descricao = ""
        }
    }

    async handleSaveCfopEntrada() {

        let copy2 = Object.assign({}, SpedEfdStore.obs.cfop_entrada)

        copy2.cfop_entrada = SpedEfdStore.obs.cfop_entrada.cfop_entrada.codigo ? SpedEfdStore.obs.cfop_entrada.cfop_entrada.codigo : SpedEfdStore.obs.cfop_entrada.cfop_entrada
        copy2.cfops_saida = SpedEfdStore.obs.cfop_entrada.cfops_saida?.map(x => x.codigo)
        copy2.csts_selecionados = SpedEfdStore.obs.cfop_entrada.csts_selecionados?.map(x => x.codigo)
        copy2.config_id = SpedEfdStore.obs.config_id


        if (copy2.cfop_entrada == "") {
            toast.warning('CFOP de Entrada Obrigatório!', {});
            return;
        }

        if (copy2.cfops_saida.length == 0) {
            toast.warning('Adicione pelo menos um CFOP de Saída!', {});
            return;
        }

        if (copy2.cst_saida == "selecione") {
            if (copy2.csts_selecionados.length == 0) {
                toast.warning('Selecione um CST ou mude para Todos', {});
                return;
            }
        }

        if (!SpedEfdStore.obs.isEdit) {
            await SpedEfdStore.handleSaveCfop(copy2)
        } else {
            await SpedEfdStore.handleUpdateCfop(copy2)
        }
    }

    async deleteCFOPS(id) {
        await SpedEfdStore.deletarCFOPS(id)
    }

    cleanOnClose() {
        this.obs.cfop_estadual_entrada = ""
        this.obs.cfop_estadual_saida = ""
        this.obs.cfop_interestadual_entrada = ""
        this.obs.cfop_interestadual_saida = ""
        SpedEfdStore.obs.deletarProdutos = []
        this.obs.open_adiciona_cfop_produto = false
        SpedEfdStore.obs.cfop_entrada_estadual_especifico = []
        SpedEfdStore.obs.cfop_saida_estadual_especifico = []
        SpedEfdStore.obs.cfop_entrada_interestadual_especifico = []
        SpedEfdStore.obs.cfop_saida_interestadual_especifico = []

    }

    onCloseGeneric() {
        this.obs.open_create_produto_generico = false
        this.obs.produto_generico_cest = ""
        this.obs.produto_generico_ncm = ""
        this.obs.produto_generico_descricao = ""
        this.obs.produto_generico_gtin = ""
        this.obs.produto_generico_unidade = ""
        this.obs.selectedGenericProduto = newIProdutoGenerico();
        SpedEfdStore.obs.deletarProdutos = []
    }

    async handleDesvincularGeneric(itens: any) {
        await SpedEfdStore.handleDesvincularGenerico(itens)
        await SpedEfdStore.handleBuscaProdutos(SpedEfdStore.obs.selectedEmpresa.cnpj, SpedEfdStore.obs.produtos_current, SpedEfdStore.obs.filter_produtos_sped)
    }

    async handleVincularGeneric(itens: any) {
        await SpedEfdStore.handleBuscaProdutosGenericosAll(SpedEfdStore.obs.selectedEmpresa.cnpj)
        SpedEfdStore.obs.deletarProdutos = []
        SpedEfdStore.obs.deletarProdutos.push(itens)
        this.obs.open_create_produto_generico = true
    }

    handleEditProduto(itens: any) {
        this.obs.produto_id = itens.id
        this.obs.produto_cest = itens.cest || ""
        this.obs.produto_ncm = itens.ncm_sh || itens.ncm
        this.obs.produto_descricao = itens.descricao || ""
        this.obs.produto_gtin = itens.gtin || ""
        this.obs.generic_id = itens.generic_id || null
        this.obs.produto_unidade = itens.unidade
        this.obs.produto_cnpj = itens.cnpj

        this.obs.open_edit_produto = true
    }

    onCloseEdit() {
        this.obs.open_edit_produto = false
        this.obs.produto_cest = ""
        this.obs.produto_ncm = ""
        this.obs.produto_descricao = ""
        this.obs.produto_gtin = ""
        this.obs.produto_id = ""
    }

    async handleSaveEditProduto() {

        let cest = this.obs.produto_cest.replace(/\_/g, "").replace(/\./g, "")
        let ncm = this.obs.produto_ncm.replace(/\_/g, "").replace(/\./g, "")

        if (this.obs.produto_descricao == "") {
            toast.warning('Insira uma Descrição!', {});
            return;
        }

        if (ncm == "" || ncm.length != 8) {
            toast.warning('Insira um NCM!', {});
            return;
        }

        let params = {
            cest: cest,
            ncm_sh: ncm,
            descricao: this.obs.produto_descricao,
            gtin: this.obs.produto_gtin,
            id: this.obs.produto_id,
            unidade: this.obs.produto_unidade,
            cnpj: this.obs.produto_cnpj,
        }

        this.obs.open_edit_produto = false
        await SpedEfdStore.handleSaveEditProduto(params)
    }

    render() {

        const formaterDetalhes = (cell, row) => {
            return (
                <>
                    {row.cfop_estadual_entrada || row.cfop_estadual_saida || row.cfop_interestadual_entrada || row.cfop_interestadual_saida ?
                        <>
                            <MDBBtn color="default" rounded size="sm" onClick={() => this.handleEditCFOPS(row)}>
                                <img src="/images/edit.png" width={15} />
                            </MDBBtn>
                            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                                <MDBBtn color="default" rounded size="sm" >
                                    <img src="/images/bin.png" width="25px" />

                                </MDBBtn>
                                <div>
                                    <H5>Confirmar exclusão?</H5>
                                    <p>Confirmar exclusão de CFOPS do produto?</p>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: 15,
                                        }}
                                    >
                                        <Button
                                            className={Classes.POPOVER_DISMISS}
                                            style={{ marginRight: 10 }}
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            intent="danger"
                                            className={Classes.POPOVER_DISMISS}
                                            onClick={() => this.deleteCFOPS(row.id)}
                                        >
                                            Excluir
                                        </Button>
                                    </div>
                                </div>
                            </Popover>
                        </>
                        : <></>}
                </>
            )
        }

        const formaterVinculado = (cell, row) => {
            return (
                <>
                    {row.generic_id ?

                        <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} >
                            <MDBBtn color="default" rounded size="sm">
                                <img src="/images/checked.png" width="25px" />
                            </MDBBtn>
                            <div>
                                <H5>Confirmar desvinculo?</H5>
                                <p style={{ fontSize: 11 }}>Tem certeza de que deseja desvincular esse item?</p>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        marginTop: 15,
                                    }}
                                >
                                    <Button
                                        className={Classes.POPOVER_DISMISS}
                                        style={{ marginRight: 10 }}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        intent="danger"
                                        className={Classes.POPOVER_DISMISS}
                                        onClick={() => this.handleDesvincularGeneric(row)}
                                    >
                                        Desvincular
                                    </Button>
                                </div>
                            </div>
                        </Popover>
                        :
                        <MDBBtn color="default" rounded size="sm" onClick={() => this.handleVincularGeneric(row)}>
                            <img src="/images/block.png" width="25px" />
                        </MDBBtn>
                    }
                </>
            );
        }

        const formaterEdit = (cell, row) => {
            return (<MDBBtn color="default" rounded size="sm" onClick={() => this.handleEditProduto(row)}>
                <img src="/images/edit.png" width={15} />
            </MDBBtn>)
        }

        let produtos = SpedEfdStore.obs.index_produtos?.map(obj => {
            return (
                {
                    id: obj._id || obj.id,
                    cest: obj.cest,
                    ncm_sh: obj.ncm_sh,
                    gtin: obj.gtin,
                    cnpj: obj.cnpj,
                    descricao: obj.descricao,
                    generic_id: obj.generic_id,
                    unidade: obj.unidade,
                    cfop_estadual_entrada: obj.cfop_estadual_entrada,
                    cfop_estadual_saida: obj.cfop_estadual_saida,
                    cfop_interestadual_entrada: obj.cfop_interestadual_entrada,
                    cfop_interestadual_saida: obj.cfop_interestadual_saida,
                    campo_concatenado: obj.campo_concatenado,
                    cfop_entrada_estadual_especifico: obj.cfop_entrada_estadual_especifico,
                    cfop_saida_estadual_especifico: obj.cfop_saida_estadual_especifico,
                    cfop_entrada_interestadual_especifico: obj.cfop_entrada_interestadual_especifico,
                    cfop_saida_interestadual_especifico: obj.cfop_saida_interestadual_especifico,
                }
            );
        })

        const selectRowProp = {
            mode: "checkbox",
            clickToSelect: false,
            onSelectAll: this.onSelectAll,
            columnWidth: "40px",
            onSelect: this.onSelect,
            bgColor: "rgba(27, 98, 111, 0.1)",
            selected: SpedEfdStore.obs.deletarProdutos?.map(value => value.id),
        };

        const returnLabel = (produto: IProdutoGenerico) => {
            let new_label = ""
            if (produto.cest != "") {
                new_label += `CEST: ${produto.cest}`
            }

            if (produto.ncm != "" && new_label != "") {
                new_label += ` - NCM: ${produto.ncm}`
            }

            if (produto.ncm != "" && new_label == "") {
                new_label += `NCM: ${produto.ncm}`
            }

            return new_label
        }


        const deleteCfopSaidaEstadualEspecifico = (cell, row) => {
            return (
                <MDBBtn color="default" rounded size="sm" onClick={() => this.deleteCfopSaidaEstadualEspecifico(row.codigo)}>
                    <img src="/images/bin.png" width={25} />
                </MDBBtn>
            )
        }
        const deleteCfopEntradaEstadualEspecifico = (cell, row) => {
            return (
                <MDBBtn color="default" rounded size="sm" onClick={() => this.deleteCfopEntradaEstadualEspecifico(row.codigo)}>
                    <img src="/images/bin.png" width={25} />
                </MDBBtn>
            )
        }
        const deleteCfopSaidaInterEspecifico = (cell, row) => {
            return (
                <MDBBtn color="default" rounded size="sm" onClick={() => this.deleteCfopSaidaInterEspecifico(row.codigo)}>
                    <img src="/images/bin.png" width={25} />
                </MDBBtn>
            )
        }
        const deleteCfopEntradaInterEspecifico = (cell, row) => {
            return (
                <MDBBtn color="default" rounded size="sm" onClick={() => this.deleteCfopEntradaInterEspecifico(row.codigo)}>
                    <img src="/images/bin.png" width={25} />
                </MDBBtn>
            )
        }

        let produtoText = this.obs.selectedGenericProduto.descricao != "" ? `${this.obs.selectedGenericProduto.descricao.substring(0, 38)} - ${returnLabel(this.obs.selectedGenericProduto)}`
            : "Selecione um Produto Genérico";

        return (
            <>
                <MDBRow style={{ display: "flex", width: "100%" }}>
                    <MDBCol md="3">
                        <InputGroup
                            round
                            leftIcon="search"
                            style={{ borderRadius: 10 }}
                            placeholder="Filtrar (ID, NCM, CEST, GTIN, DESCRIÇÃO)"
                            value={SpedEfdStore.obs.filter_produtos_sped}
                            onChange={(e: any) => this.handleBuscaPaged(e.target.value)} />
                    </MDBCol>

                    <MDBRow>
                        <div style={{ width: "155px", marginBottom: "30px", float: 'left', marginLeft: "15px" }}>
                            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                                <Tooltip
                                    content={`Deletar ${SpedEfdStore.obs.deletarProdutos.length}`}
                                    disabled={SpedEfdStore.obs.deletarProdutos.length == 0}
                                >
                                    <Button
                                        loading={SpedEfdStore.obs.loading}
                                        disabled={SpedEfdStore.obs.deletarProdutos.length == 0}
                                        icon="issue"
                                    >
                                        Deletar Selecionados
                                    </Button>
                                </Tooltip>
                                <div>
                                    <H5>Confirmar exclusão</H5>
                                    <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
                                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15, }}>

                                        <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }} onClick={() => SpedEfdStore.resetDeletarItems()}>
                                            Cancelar
                                        </Button>

                                        <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.handleDeletar()}>
                                            Deletar
                                        </Button>
                                    </div>
                                </div>
                            </Popover>
                        </div>

                        <div style={{ width: "100px", marginBottom: "30px", float: 'left', marginLeft: "15px" }}>
                            <Tooltip
                                content={`Incluir para ${SpedEfdStore.obs.deletarProdutos.length}`}
                                disabled={SpedEfdStore.obs.deletarProdutos.length == 0}
                            >
                                <Button
                                    disabled={SpedEfdStore.obs.deletarProdutos.length == 0}
                                    onClick={() => this.handleIncluirCfopProduto()}
                                >
                                    Incluir CFOP
                                </Button>
                            </Tooltip>
                        </div>

                        <div style={{ width: "120px", marginBottom: "30px", float: 'left', marginLeft: "15px" }}>
                            <Tooltip
                                content={`Incluir para ${SpedEfdStore.obs.deletarProdutos.length}`}
                                disabled={SpedEfdStore.obs.deletarProdutos.length == 0}
                            >
                                <Button
                                    disabled={SpedEfdStore.obs.deletarProdutos.length == 0}
                                    onClick={() => this.handleProdutoGenerico()}
                                >
                                    Produto Genérico
                                </Button>
                            </Tooltip>
                        </div>

                        <div style={{ marginLeft: "20px" }}>
                            <Button
                                text="Exportar Produtos"
                                className="btnDefault btnBuscarNfe btnRoxo"
                                onClick={() => SpedEfdStore.exportProdutos(SpedEfdStore.obs.selectedEmpresa.cnpj)}
                                loading={SpedEfdStore.obs.loading_export}
                            />
                        </div>
                    </MDBRow>

                    <MDBCol>
                        <div style={{ float: 'right' }}>
                            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} position={Position.LEFT}>
                                <Tooltip content={SpedEfdStore.obs.filter_produtos_sped.length < 2 ? "Filtro Obrigatório" : ""}>
                                    <Button className="btnDefault btnBuscarNfe btnVerde" loading={SpedEfdStore.obs.loadingSelectAll} disabled={SpedEfdStore.obs.filter_produtos_sped.length < 2}>
                                        Selecionar Todos
                                    </Button>
                                </Tooltip>
                                <div>
                                    <H5>Confirmar Seleção</H5>
                                    <p style={{ fontSize: 11 }}>Tem certeza que deseja selecionar todos os {SpedEfdStore.obs.produtos_length} {" "}</p>
                                    {SpedEfdStore.obs.produtos_length == 1 ? "item?" : "itens?"}
                                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}
                                    >
                                        <Button
                                            className={Classes.POPOVER_DISMISS}
                                            style={{ marginRight: 10 }}
                                            onClick={() => SpedEfdStore.resetDeletarItems()}
                                        >
                                            Não
                                        </Button>
                                        <Button
                                            intent="danger"
                                            className={Classes.POPOVER_DISMISS}
                                            onClick={() => this.handleDeletarTodos()}
                                        >
                                            Sim
                                        </Button>
                                    </div>
                                </div>
                            </Popover>
                        </div>
                    </MDBCol>

                    <Dialog
                        isOpen={this.obs.open_adiciona_cfop_produto}
                        onClose={() => this.obs.open_adiciona_cfop_produto = false}
                        className="AlertUser"
                    >
                        <h2 className="titleSEFAZ">Incluir CFOP</h2>
                        <Tabs
                            id="tabs_entrada"
                            className={"tabsCalculos"}
                        >

                            <Tab
                                id="entrada"
                                title="Entrada"
                                panel={
                                    <>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ width: "90%" }}>
                                                <FormGroup label="CFOP Estadual">
                                                    <InputMask
                                                        mask="9-999"
                                                        className={SpedEfdStore.obs.isEdit ? "form-control inputDisabled" : "form-control"}
                                                        onChange={(e) => this.obs.cfop_estadual_entrada = e.target.value}
                                                        disabled={SpedEfdStore.obs.isEdit}
                                                        defaultValue={this.obs.cfop_estadual_entrada} />
                                                </FormGroup>
                                            </div>
                                            <div style={{ width: "10%", textAlign: "center", marginTop: "25px" }}>
                                                <MDBBtn color="default" size="sm" onClick={() => this.obs.open_adiciona_cfops_estadual_saida = true}>
                                                    <img src="/images/configuration.png" width={25} />
                                                </MDBBtn>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ width: "90%" }}>
                                                <FormGroup label="CFOP Interestadual">
                                                    <InputMask
                                                        mask="9-999"
                                                        className={SpedEfdStore.obs.isEdit ? "form-control inputDisabled" : "form-control"}
                                                        onChange={(e) => this.obs.cfop_interestadual_entrada = e.target.value}
                                                        disabled={SpedEfdStore.obs.isEdit}
                                                        defaultValue={this.obs.cfop_interestadual_entrada} />
                                                </FormGroup>
                                            </div>
                                            <div style={{ width: "10%", textAlign: "center", marginTop: "25px" }}>
                                                <MDBBtn color="default" size="sm" onClick={() => this.obs.open_adiciona_cfops_interestadual_saida = true}>
                                                    <img src="/images/configuration.png" width={25} />
                                                </MDBBtn>
                                            </div>
                                        </div>

                                    </>
                                }
                            />
                        </Tabs>

                        <Tabs
                            id="tabs_saida"
                            className={"tabsCalculos"}
                        >
                            <Tab
                                id="saida"
                                title="Saída"
                                panel={
                                    <>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ width: "90%" }}>
                                                <FormGroup label="CFOP Estadual">
                                                    <InputMask
                                                        mask="9-999"
                                                        className={SpedEfdStore.obs.isEdit ? "form-control inputDisabled" : "form-control"}
                                                        onChange={(e) => this.obs.cfop_estadual_saida = e.target.value}
                                                        disabled={SpedEfdStore.obs.isEdit}
                                                        defaultValue={this.obs.cfop_estadual_saida} />
                                                </FormGroup>
                                            </div>
                                            <div style={{ width: "10%", textAlign: "center", marginTop: "25px" }}>
                                                <MDBBtn color="default" size="sm" onClick={() => this.obs.open_adiciona_cfops_estadual_entrada = true}>
                                                    <img src="/images/configuration.png" width={25} />
                                                </MDBBtn>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ width: "90%" }}>
                                                <FormGroup label="CFOP Interestadual">
                                                    <InputMask
                                                        mask="9-999"
                                                        className={SpedEfdStore.obs.isEdit ? "form-control inputDisabled" : "form-control"}
                                                        onChange={(e) => this.obs.cfop_interestadual_saida = e.target.value}
                                                        disabled={SpedEfdStore.obs.isEdit}
                                                        defaultValue={this.obs.cfop_interestadual_saida} />
                                                </FormGroup>
                                            </div>
                                            <div style={{ width: "10%", textAlign: "center", marginTop: "25px" }}>
                                                <MDBBtn color="default" size="sm" onClick={() => this.obs.open_adiciona_cfops_interestadual_entrada = true}>
                                                    <img src="/images/configuration.png" width={25} />
                                                </MDBBtn>
                                            </div>
                                        </div>
                                    </>
                                }
                            />
                        </Tabs>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button text="Cancelar" onClick={() => this.cleanOnClose()} />
                            <Button text="Salvar" intent="primary" onClick={() => this.handleSaveCfopProduto()} />
                        </div>
                    </Dialog>

                    <Dialog
                        isOpen={this.obs.open_edit_produto}
                        onClose={() => this.obs.open_edit_produto = false}
                        className="AlertUser"
                    >
                        <h2 className="titleSEFAZ">Editar Produto</h2>

                        <FormGroup label="CEST">
                            <InputMask
                                mask="99.999.99"
                                className="form-control"
                                onChange={(e) => this.obs.produto_cest = e.target.value}
                                defaultValue={this.obs.produto_cest} />
                        </FormGroup>

                        <FormGroup label="NCM">
                            <InputMask
                                mask="9999.99.99"
                                className="form-control"
                                onChange={(e) => this.obs.produto_ncm = e.target.value}
                                defaultValue={this.obs.produto_ncm} />
                        </FormGroup>

                        <FormGroup label="GTIN">
                            <InputGroup value={this.obs.produto_gtin} onChange={(e) => this.obs.produto_gtin = e.target.value} />
                        </FormGroup>

                        <FormGroup label="Descrição">
                            <TextArea style={{ width: "100%" }} value={this.obs.produto_descricao} onChange={(e) => this.obs.produto_descricao = e.target.value} />
                        </FormGroup>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button text="Cancelar" onClick={() => this.onCloseEdit()} />
                            <Button text="Salvar" intent="primary" onClick={() => this.handleSaveEditProduto()} />
                        </div>
                    </Dialog>

                    <Dialog
                        isOpen={this.obs.open_create_produto_generico}
                        onClose={() => this.obs.open_create_produto_generico = false}
                        className="AlertUser"
                    >
                        <h2 className="titleSEFAZ">Produto Genérico</h2>

                        <Tabs
                            id="tabs_saida"
                            className={"tabsCalculos"}
                            selectedTabId={this.obs.select_tab_generic}
                            onChange={(tabId) => this.hanldeChangeTabGeneric(String(tabId))}
                        >

                            <Tab
                                id="create_generic"
                                title="Criar Produto Genérico"
                                panel={
                                    <>
                                        <MDBRow>
                                            <MDBCol>
                                                <FormGroup label="CEST">
                                                    <InputMask
                                                        mask="99.999.99"
                                                        className="form-control"
                                                        onChange={(e) => this.obs.produto_generico_cest = e.target.value}
                                                        defaultValue={this.obs.produto_generico_cest} />
                                                </FormGroup>
                                            </MDBCol>
                                            <MDBCol>
                                                <FormGroup label="NCM">
                                                    <InputMask
                                                        mask="9999.99.99"
                                                        className="form-control"
                                                        onChange={(e) => this.obs.produto_generico_ncm = e.target.value}
                                                        defaultValue={this.obs.produto_generico_ncm} />
                                                </FormGroup>
                                            </MDBCol>
                                            <MDBCol>
                                                <FormGroup label="UNIDADE">
                                                    <InputGroup value={this.obs.produto_generico_unidade} onChange={(e) => this.obs.produto_generico_unidade = e.target.value} />
                                                </FormGroup>
                                            </MDBCol>
                                        </MDBRow>
                                        <FormGroup label="GTIN">
                                            <InputGroup value={this.obs.produto_generico_gtin} onChange={(e) => this.obs.produto_generico_gtin = e.target.value} />
                                        </FormGroup>

                                        <FormGroup label="Descrição">
                                            <TextArea style={{ width: "100%" }} value={this.obs.produto_generico_descricao} onChange={(e) => this.obs.produto_generico_descricao = e.target.value} />
                                        </FormGroup>
                                    </>
                                }
                            />
                            <Tab
                                id="select_generic"
                                title="Selecionar Produto Genérico"
                                panel={
                                    <>
                                        <FormGroup
                                            className="empresaSelect"
                                        >
                                            <ProdutoGenericoSelect
                                                items={SpedEfdStore.obs.generic_produtos_all}
                                                itemRenderer={renderProduto}
                                                itemPredicate={filterProduto}
                                                onItemSelect={(e: IProdutoGenerico) => this.obs.selectedGenericProduto = e}
                                            >
                                                <Button
                                                    text={produtoText}
                                                    rightIcon="double-caret-vertical"
                                                    alignText={Alignment.LEFT}
                                                />
                                            </ProdutoGenericoSelect>
                                        </FormGroup>
                                    </>
                                }
                            />

                        </Tabs>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button text="Cancelar" onClick={() => this.onCloseGeneric()} />
                            <Button text="Salvar" intent="primary" onClick={() => this.handleSaveProdutoGenerico()} />
                        </div>
                    </Dialog>

                </MDBRow>

                <BootstrapTable
                    data={produtos}
                    selectRow={selectRowProp}
                >
                    <TableHeaderColumn dataField="id" width="1%" isKey={true} hidden >#</TableHeaderColumn>
                    <TableHeaderColumn dataField="campo_concatenado" width="60%">ID</TableHeaderColumn>
                    <TableHeaderColumn dataField="cest" width="20%">CEST</TableHeaderColumn>
                    <TableHeaderColumn dataField="ncm_sh" width="20%">NCM</TableHeaderColumn>
                    <TableHeaderColumn dataField="gtin" width="30%">GTIN</TableHeaderColumn>
                    <TableHeaderColumn dataField="descricao" width="80%">Descrição</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={formaterVinculado} width="30%">Vinculado</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={formaterEdit} width="30%">Editar</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={formaterDetalhes} width="20%">CFOP</TableHeaderColumn>
                </BootstrapTable>

                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                  <Pager
                      currentPage={SpedEfdStore.obs.produtos_current}
                      totalCount={SpedEfdStore.obs.produtos_length}
                      pageSize={100}
                      onPageChange={(page) => this.handleChangePage(SpedEfdStore.obs.produtos_current = page)}
                  />
                </div>

                <LoadingModal open={SpedEfdStore.obs.loading} onClose={() => SpedEfdStore.obs.loading = false} title={"Deletando produtos"} />

                <Alert
                    cancelButtonText="Fechar"
                    confirmButtonText="Adicionar"
                    isOpen={this.obs.open_adiciona_cfops_estadual_saida}
                    onClose={() => this.obs.open_adiciona_cfops_estadual_saida = false}
                    onConfirm={() => this.obs.open_adiciona_cfops_estadual_saida = false}
                    canOutsideClickCancel={true}
                    intent={Intent.PRIMARY}
                    className="AlertUser"
                >
                    <div style={{ marginBottom: "60px" }}>

                        <h2 className="titleSEFAZ">Adicionar CFOP Saída</h2>
                        <div style={{ display: "flex" }}>
                            <FormGroup label="CFOPs Saída" style={{ width: "200px" }}>
                                <InputMask
                                    mask="9-999"
                                    value={SpedEfdStore.obs.input_cfop_saida_especifico}
                                    className="form-control"
                                    onChange={(e) => this.handleBuscaCFOPSaida(e.target.value)}
                                />
                            </FormGroup>
                            <div style={{ marginTop: "26px" }}>
                                <MDBBtn className="btnDefault btnBuscarNfe"
                                    onClick={() => this.InserirCFOPSaidaEstadual()}
                                    style={{ marginLeft: 20 }}
                                >
                                    Inserir
                                </MDBBtn>
                            </div>
                        </div>
                        <FormGroup label="Descrição">
                            <TextArea style={{ width: "100%" }} disabled value={SpedEfdStore.obs.cfop_saida_descricao} />
                        </FormGroup>

                        <BootstrapTable
                            className="dados-recolhimento"
                            data={SpedEfdStore.obs.cfop_entrada_estadual_especifico}
                        >
                            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                            <TableHeaderColumn dataField="codigo" width="50%">CFOP Saida</TableHeaderColumn>
                            <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={deleteCfopSaidaEstadualEspecifico} width="20%"></TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </Alert>

                <Alert
                    cancelButtonText="Fechar"
                    confirmButtonText="Adicionar"
                    isOpen={this.obs.open_adiciona_cfops_interestadual_saida}
                    onClose={() => this.obs.open_adiciona_cfops_interestadual_saida = false}
                    onConfirm={() => this.obs.open_adiciona_cfops_interestadual_saida = false}
                    canOutsideClickCancel={true}
                    intent={Intent.PRIMARY}
                    className="AlertUser"
                >
                    <div style={{ marginBottom: "60px" }}>

                        <h2 className="titleSEFAZ">Adicionar CFOP Saída</h2>
                        <div style={{ display: "flex" }}>
                            <FormGroup label="CFOPs Saída" style={{ width: "200px" }}>
                                <InputMask
                                    mask="9-999"
                                    value={SpedEfdStore.obs.input_cfop_saida_especifico}
                                    className="form-control"
                                    onChange={(e) => this.handleBuscaCFOPSaida(e.target.value)}
                                />
                            </FormGroup>
                            <div style={{ marginTop: "26px" }}>
                                <MDBBtn className="btnDefault btnBuscarNfe"
                                    onClick={() => this.InserirCFOPSaidaInterestadual()}
                                    style={{ marginLeft: 20 }}
                                >
                                    Inserir
                                </MDBBtn>
                            </div>
                        </div>
                        <FormGroup label="Descrição">
                            <TextArea style={{ width: "100%" }} disabled value={SpedEfdStore.obs.cfop_saida_descricao} />
                        </FormGroup>

                        <BootstrapTable
                            className="dados-recolhimento"
                            data={SpedEfdStore.obs.cfop_entrada_interestadual_especifico}
                        >
                            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                            <TableHeaderColumn dataField="codigo" width="50%">CFOP Saida</TableHeaderColumn>
                            <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={deleteCfopSaidaInterEspecifico} width="20%"></TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </Alert>


                <Alert
                    cancelButtonText="Fechar"
                    confirmButtonText="Adicionar"
                    isOpen={this.obs.open_adiciona_cfops_estadual_entrada}
                    onClose={() => this.obs.open_adiciona_cfops_estadual_entrada = false}
                    onConfirm={() => this.obs.open_adiciona_cfops_estadual_entrada = false}
                    canOutsideClickCancel={true}
                    intent={Intent.PRIMARY}
                    className="AlertUser"
                >
                    <div style={{ marginBottom: "60px" }}>

                        <h2 className="titleSEFAZ">Adicionar CFOP Entrada</h2>
                        <div style={{ display: "flex" }}>
                            <FormGroup label="CFOPs Entrada" style={{ width: "200px" }}>
                                <InputMask
                                    mask="9-999"
                                    value={SpedEfdStore.obs.input_cfop_entrada_especifico}
                                    className="form-control"
                                    onChange={(e) => this.handleBuscaCFOPEntrada(e.target.value)}
                                />
                            </FormGroup>
                            <div style={{ marginTop: "26px" }}>
                                <MDBBtn className="btnDefault btnBuscarNfe"
                                    onClick={() => this.InserirCFOPEntradaEstadual()}
                                    style={{ marginLeft: 20 }}
                                >
                                    Inserir
                                </MDBBtn>
                            </div>
                        </div>
                        <FormGroup label="Descrição">
                            <TextArea style={{ width: "100%" }} disabled value={SpedEfdStore.obs.cfop_entrada_descricao} />
                        </FormGroup>

                        <BootstrapTable
                            className="dados-recolhimento"
                            data={SpedEfdStore.obs.cfop_saida_estadual_especifico}
                        >
                            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                            <TableHeaderColumn dataField="codigo" width="50%">CFOP Saida</TableHeaderColumn>
                            <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={deleteCfopEntradaEstadualEspecifico} width="20%"></TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </Alert>

                <Alert
                    cancelButtonText="Fechar"
                    confirmButtonText="Adicionar"
                    isOpen={this.obs.open_adiciona_cfops_interestadual_entrada}
                    onClose={() => this.obs.open_adiciona_cfops_interestadual_entrada = false}
                    onConfirm={() => this.obs.open_adiciona_cfops_interestadual_entrada = false}
                    canOutsideClickCancel={true}
                    intent={Intent.PRIMARY}
                    className="AlertUser"
                >
                    <div style={{ marginBottom: "60px" }}>

                        <h2 className="titleSEFAZ">Adicionar CFOP Entrada</h2>
                        <div style={{ display: "flex" }}>
                            <FormGroup label="CFOPs Entrada" style={{ width: "200px" }}>
                                <InputMask
                                    mask="9-999"
                                    value={SpedEfdStore.obs.input_cfop_entrada_especifico}
                                    className="form-control"
                                    onChange={(e) => this.handleBuscaCFOPEntrada(e.target.value)}
                                />
                            </FormGroup>
                            <div style={{ marginTop: "26px" }}>
                                <MDBBtn className="btnDefault btnBuscarNfe"
                                    onClick={() => this.InserirCFOPEntradaInterestadual()}
                                    style={{ marginLeft: 20 }}
                                >
                                    Inserir
                                </MDBBtn>
                            </div>
                        </div>
                        <FormGroup label="Descrição">
                            <TextArea style={{ width: "100%" }} disabled value={SpedEfdStore.obs.cfop_entrada_descricao} />
                        </FormGroup>

                        <BootstrapTable
                            className="dados-recolhimento"
                            data={SpedEfdStore.obs.cfop_saida_interestadual_especifico}
                        >
                            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                            <TableHeaderColumn dataField="codigo" width="50%">CFOP Saida</TableHeaderColumn>
                            <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={deleteCfopEntradaInterEspecifico} width="20%"></TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </Alert>
            </>
        )
    }
}